import { McpServersContract } from '@terra/shared-contracts-mcp-servers';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const mcpServersClient = createTerraOrpcClient({
  contract: McpServersContract,
  serviceName: SERVICE_NAME,
});
